import { Component } from '@angular/core';

@Component({
  selector: 'g4c-root',
  templateUrl: './app.component.html',
  styleUrls: [ ]
})
export class AppComponent { }
